// Reconstruct only an identified section/letter boundary, never paragraph numbers.
export function hebrewNumber(number) {
  let n = Number(number);
  if (!Number.isInteger(n) || n < 1 || n > 999) return "";
  let label = "";
  for (const [value, letter] of [[400,"ת"],[300,"ש"],[200,"ר"],[100,"ק"]]) {
    while (n >= value) { label += letter; n -= value; }
  }
  if (n === 15) return label + "טו";
  if (n === 16) return label + "טז";
  for (const [value, letter] of [[90,"צ"],[80,"פ"],[70,"ע"],[60,"ס"],[50,"נ"],[40,"מ"],[30,"ל"],[20,"כ"],[10,"י"],[9,"ט"],[8,"ח"],[7,"ז"],[6,"ו"],[5,"ה"],[4,"ד"],[3,"ג"],[2,"ב"],[1,"א"]]) {
    if (n >= value) { label += letter; n -= value; }
  }
  return label;
}
export function sectionOpeningLetter(text, opening) {
  const identity = text.tocTargetRef || text.readerRef || text.ref || "";
  const match = identity.match(/:(?:seif|letter):(\d+)$/) || identity.match(/(?:Section|Seif|Letter)\s+(\d+)$/i);
  if (!match) return "";
  const label = hebrewNumber(match[1]);
  // An original opening already in the text takes precedence (bold or plain).
  const plain = String(opening || "").replace(/\*\*|__/g, "").trim();
  if (!plain || new RegExp(`^${label}[.׳״'"’)]?(?:\\s|$)`).test(plain)) return "";
  return label;
}
